import { platform, PlatformType } from "@/lib/platform";

export function usePlatform(): PlatformType {
  return platform();
}
